import axios from './api';
import API_URL from '../apiconfig';

export interface ImpersonationSession {
  employeeId: string;
  businessId: string;
  business: { businessId: string; name: string; urlPath: string };
  admin: {
    userId: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
  };
  expiresAt: string;
}

export const getImpersonationsForBusiness = async (businessId: string) => {
  const response = await axios.get(`${API_URL}/v1/impersonation`, {
    params: { businessId },
  });
  return response.data.result as ImpersonationSession[];
};

export const endImpersonation = async (
  businessId: string,
  employeeId?: string,
) => {
  const response = await axios.delete(`${API_URL}/v1/impersonation`, {
    data: { businessId, ...(employeeId ? { employeeId } : {}) },
  });
  return response.data.result as { deleted: number };
};
